import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-yin",
  "use": "icon-yin-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-yin\"><defs><clipPath id=\"icon-yin_a\"><path transform=\"translate(485 615)\" d=\"M0 0h14v14H0z\" /></clipPath></defs><g transform=\"translate(-485 -615)\" clip-path=\"url(#icon-yin_a)\"><path d=\"M496.929 621.429a3.036 3.036 0 0 0-5.675-1.945 2.361 2.361 0 0 0-3.724 1.927v.011a2.361 2.361 0 1 0-.171 4.716h9.277a2.361 2.361 0 0 0 .292-4.7z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol